//Improved Infinite Scroll with Intersection Observer:
let icurrentPage = 2;
let loading = false;
let noMoreProducts = false;
let observer = null;

// Configurable options
const ROOT_MARGIN = '800px'; // Load when sentinel is 800px away from viewport

function loadMoreProducts() {
  console.log('🔄 loadMoreProducts called - loading:', loading, 'noMoreProducts:', noMoreProducts);

  if (loading || noMoreProducts) {
    console.log('❌ Skipping load - already loading or no more products');
    return;
  }

  loading = true;
  console.log('📡 Starting to fetch page:', icurrentPage);
  const spinner = document.getElementById('loading-spinner');
  if (spinner) spinner.classList.remove('hidden');

  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set('page', icurrentPage);
  
  console.log('📡 Starting to fetch:', nextUrl.toString());

  fetch(nextUrl.toString()) // ⬅️ Use the new URL object here
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.text();
    })
    .then(data => {
      // 🆕 Check for 'no products found' anywhere in the response
      if (data.toLowerCase().includes('no products found')) {
        console.log('🚫 "No products found" detected in fetched data');
        noMoreProducts = true;
        // Stop observing and remove sentinel
        if (observer) {
          console.log('👁️ Disconnecting observer');
          observer.disconnect();
          observer = null;
        }
        // Delete sentinel element from DOM
        const sentinel = document.getElementById('infinite-scroll-sentinel');
        if (sentinel) {
          console.log('🗑️ Removing sentinel element');
          sentinel.remove();
        }
        if (spinner) spinner.classList.add('hidden');
        loading = false;
        return;
      }

      console.log('📦 Received data, parsing...');
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const firstGrid = doc.querySelector('ul.product-grid');
      const newItems = firstGrid ? firstGrid.querySelectorAll('li') : [];
      console.log('🎯 Found', newItems.length, 'new items');

      if (newItems.length === 0) {
        console.log('🚫 No more products available');
        noMoreProducts = true;
        // Stop observing when no more products
        if (observer) {
          console.log('👁️ Disconnecting observer');
          observer.disconnect();
          observer = null;
        }
        // Delete sentinel element from DOM
        const sentinel = document.getElementById('infinite-scroll-sentinel');
        if (sentinel) {
          console.log('🗑️ Removing sentinel element');
          sentinel.remove();
        }
        if (spinner) spinner.classList.add('hidden');
        loading = false;
        return;
      }

      const container = document.querySelector('ul.product-grid');
      if (container) {
        console.log('➕ Adding', newItems.length, 'items to container');
        const fragment = document.createDocumentFragment();
        newItems.forEach(item => fragment.appendChild(item.cloneNode(true)));
        container.appendChild(fragment);

        try {
          const regiosPayload = Array.from(newItems).map(item => {
            // 1. Try to get data from the list item itself
            let dataAttr = item.getAttribute('data-regios-info');
            
            // 2. If not found, look for the data inside the list item
            if (!dataAttr) {
              const innerCard = item.querySelector('[data-regios-info]');
              if (innerCard) {
                dataAttr = innerCard.getAttribute('data-regios-info');
              }
            }

            if (!dataAttr) return null;
            
            try {
              return JSON.parse(dataAttr);
            } catch (err) {
              console.error('❌ JSON Parse Error for item:', err);
              return null;
            }
          }).filter(Boolean);

          if (regiosPayload.length > 0) {
            console.log('💸 Firing Regios Event for', regiosPayload.length, 'products');
            
            // Define the event with bubbling enabled
            const regiosEvent = new CustomEvent("regios-dopp:collection-page:new-items", {
              bubbles: true, // <--- CRITICAL FIX: Allows event to travel up
              detail: {
                newItems: regiosPayload
              }
            });

            // Fire on both Document and Window to ensure the app hears it
            document.dispatchEvent(regiosEvent);
            window.dispatchEvent(regiosEvent);
            
          } else {
            console.warn('⚠️ No Regios data found. (Check your card-product.liquid)');
          }

        } catch (e) {
          console.warn('⚠️ Failed to trigger Regios logic:', e);
        }

      } else {
        console.warn('⚠️ Product grid container not found');
      }

      icurrentPage++;

      loading = false;
      console.log('✅ Successfully loaded page', icurrentPage - 1, '- ready for next load');
      if (spinner) spinner.classList.add('hidden');
    })
    .catch(error => {
      console.error('💥 Failed to load more products:', error);
      loading = false;
      if (spinner) spinner.classList.add('hidden');
    });
}

function initInfiniteScroll() {
  console.log('🚀 Initializing infinite scroll...');
  const sentinel = document.getElementById('infinite-scroll-sentinel');
  
  if (!sentinel) {
    console.error('❌ Infinite scroll sentinel element not found');
    return;
  }
  
  console.log('👁️ Sentinel element found:', sentinel);
  
  // Check if Intersection Observer is supported
  if (!('IntersectionObserver' in window)) {
    console.warn('⚠️ IntersectionObserver not supported, falling back to scroll listener');
    fallbackToScrollListener();
    return;
  }
  
  console.log('✅ IntersectionObserver supported, setting up observer with rootMargin:', ROOT_MARGIN);
  
  // Create intersection observer
  observer = new IntersectionObserver((entries) => {
    console.log('👁️ Observer triggered with', entries.length, 'entries');
    entries.forEach(entry => {
      console.log('🎯 Entry details:', {
        isIntersecting: entry.isIntersecting,
        intersectionRatio: entry.intersectionRatio,
        boundingClientRect: entry.boundingClientRect,
        rootBounds: entry.rootBounds
      });
      
      // Load more when sentinel enters the extended viewport area
      if (entry.isIntersecting) {
        console.log('🔥 Sentinel is intersecting - triggering load');
        loadMoreProducts();
      }
    });
  }, {
    // rootMargin creates an extended viewport - loads content before sentinel is visible
    rootMargin: ROOT_MARGIN,
    threshold: 0 // Trigger as soon as any part enters the extended area
  });
  
  // Start observing the sentinel
  console.log('👀 Starting to observe sentinel element');
  observer.observe(sentinel);
  console.log('🎉 Infinite scroll initialization complete');
}

// Fallback for browsers without Intersection Observer support
function fallbackToScrollListener() {
  const LOAD_THRESHOLD = 1500;
  const THROTTLE_DELAY = 100;
  
  function getScrollDistance() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );
    
    return documentHeight - (scrollTop + windowHeight);
  }
  
  function checkIfNeedMoreContent() {
    const distanceFromBottom = getScrollDistance();
    
    if (distanceFromBottom <= LOAD_THRESHOLD) {
      loadMoreProducts();
    }
  }
  
  function throttle(func, delay) {
    let timeoutId;
    let lastExecTime = 0;
    
    return function (...args) {
      const currentTime = Date.now();
      
      if (currentTime - lastExecTime > delay) {
        func.apply(this, args);
        lastExecTime = currentTime;
      } else {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
          lastExecTime = Date.now();
        }, delay - (currentTime - lastExecTime));
      }
    };
  }
  
  const throttledScrollHandler = throttle(checkIfNeedMoreContent, THROTTLE_DELAY);
  window.addEventListener('scroll', throttledScrollHandler, { passive: true });
  
  // Initial check and resize handler
  setTimeout(checkIfNeedMoreContent, 100);
  window.addEventListener('resize', throttle(checkIfNeedMoreContent, 250), { passive: true });
}

// Cleanup function (useful if you need to destroy the infinite scroll)
function destroyInfiniteScroll() {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  console.log('📄 DOM still loading, waiting for DOMContentLoaded...');
  document.addEventListener('DOMContentLoaded', initInfiniteScroll);
} else {
  console.log('📄 DOM already loaded, initializing immediately');
  initInfiniteScroll();
}

//End Improved Infinite Scroll